module.exports = __webpack_public_path__ + "static/media/perks-near-me.4e1b898d.svg";